"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@phishtool/ui");
const responsiveFontSizes = {
    body: {
        small: ['x1', null, 'x2'],
        medium: ['x2', null, 'x3'],
        large: ['x2', null, 'x4'],
        xl: ['x2', null, 'x5'],
    },
    heading: {
        small: ['x3'],
        medium: ['x4'],
        large: ['x3', null, 'x5'],
        xl: ['x6', null, 'x9'],
        xxl: ['x7', null, 'x10'],
    },
};
const defaultTheme = (0, ui_1.getTheme)(responsiveFontSizes);
const theme = Object.assign(Object.assign({}, defaultTheme), { radii: Object.assign(Object.assign({}, defaultTheme.radii), { primary: '4px' }), modals: {
        closeButtonColor: 'heroOrange',
    } });
exports.default = theme;
